"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

const NAVER_ANALYTICS_ID = process.env.NEXT_PUBLIC_NAVER_ANALYTICS_ID;

export function NaverAnalytics() {
  const pathname = usePathname();

  useEffect(() => {
    if (!NAVER_ANALYTICS_ID) return;

    if (!window.wcs_add) window.wcs_add = {};
    window.wcs_add["wa"] = NAVER_ANALYTICS_ID;

    if (window.wcs) {
      window.wcs.inflow("locarora.com");
      wcs_do();
    }
  }, [pathname]);

  return null;
}
